/* assets/accordion.js
   Shared toggle behaviour for the Accordion section — loaded once, cached across every page.
   Supports multiple independent accordion instances on the same page. */

document.addEventListener('DOMContentLoaded', function () {
  var allTabs = document.querySelectorAll('[data-acc-tabs]');

  allTabs.forEach(function (root) {
    var items = root.querySelectorAll('[data-acc-item]');

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-acc-toggle]');
      var content = item.querySelector('[data-acc-content]');

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = item.classList.contains('acc-active');

        // Close other items within THIS accordion instance only
        items.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('acc-active');
            other.querySelector('[data-acc-content]').style.maxHeight = 0;
          }
        });

        if (isOpen) {
          item.classList.remove('acc-active');
          content.style.maxHeight = 0;
        } else {
          item.classList.add('acc-active');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });

      window.addEventListener('resize', function () {
        if (item.classList.contains('acc-active')) {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  });
});
